import { PageTitle } from '@components/PageTitle';
import { Button } from '@components/ui/button';
import { useDimensions } from '@hooks/useDimensions';
import { type IGetNoteDetailsOutputData } from '@services/notes/dtos/getNoteDetails/OutputData';
import NoteService from '@services/notes/NoteService';
import { useQuery } from '@tanstack/react-query';
import { LoaderCircle } from 'lucide-react';
import { useNavigate, useParams } from 'react-router';

function NoteFile() {
  const params = useParams();
  const { width } = useDimensions();
  const navigate = useNavigate();

  const { data, isPending } = useQuery<IGetNoteDetailsOutputData>({
    queryFn: async () => {
      const response = await NoteService.getDetails({
        id: params.fileId!,
      });
      return response;
    },
    queryKey: ['noteDetails', params.id, params.fileId],
    refetchOnWindowFocus: false,
  });

  return (
    <div>
      <div className="flex flex-col gap-x-2">
        <PageTitle hasBackButton title="Voltar" />
        <div className="flex w-full justify-end">
          <Button
            className="w-full max-w-44 cursor-pointer"
            onClick={() =>
              navigate(
                `/anotacoes${params.id ? `/${params.id}/arquivos/${params.fileId}/editar` : `/arquivos/${params.fileId}/editar`}`,
              )
            }
            size={width < 640 ? 'sm' : 'default'}
            variant="secondary">
            EDITAR
          </Button>
        </div>
      </div>

      {isPending ? (
        <div className="flex min-h-52 flex-col items-center justify-center">
          <LoaderCircle className="size-8 animate-spin" />
          <p className="text-2xl">Carregando...</p>
        </div>
      ) : (
        <div>
          <div className="mb-4 flex flex-row items-center gap-2">
            <h1 className="text-2xl font-semibold">{data?.title}</h1>
            {data?.type === 'MEDICAMENTO' && (
              <h1 className="text-2xl">{data?.presentation}</h1>
            )}
          </div>
          <div
            className="prose prose-strong:text-inherit text-foreground prose-p:mb-1.5 prose-p:mt-0 prose-li:my-0 prose-ul:ml-6 prose-ul:mt-0 prose-ul:mb-5 marker:text-foreground max-w-screen-xl"
            dangerouslySetInnerHTML={{
              __html:
                data?.content.replaceAll(
                  '<p style="margin-left: 0px!important;"></p>',
                  '<br class="ProseMirror-trailingBreak">',
                ) || '',
            }}
          />
        </div>
      )}
    </div>
  );
}

export default NoteFile;
